"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENS_REVERSE_LOOKUP_CONTRACT_BY_NETWORK = exports.ZORA_MEDIA_CONTRACT_BY_NETWORK = void 0;
const networks_1 = require("./networks");
exports.ZORA_MEDIA_CONTRACT_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: '0xabEFBc9fD2F806065b4f3C237d4b59D9A97Bcac7',
    [networks_1.Networks.RINKEBY]: '0x7C2668BD0D3c050703CEcC956C11Bd520c26f7d4',
};
exports.ENS_REVERSE_LOOKUP_CONTRACT_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: '0x3671aE578E63FdF66ad4F3E12CC0c0d71Ac7510C',
    [networks_1.Networks.RINKEBY]: '0x34c01b31c18303Cbd4d97833bb54F70423C4d523',
};
